import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Facet, FacetFilter } from '../../../shared/models/search.model';

@Component({
  selector: 'app-partners-search-facets',
  templateUrl: './partners-search-facets.component.html',
  styleUrls: ['./partners-search-facets.component.scss'],
  standalone: false,
})
export class PartnersSearchFacetsComponent {
  @Input()
    searchFacets?: Facet[] | null;
  @Output()
    filterFacets: EventEmitter<FacetFilter> = new EventEmitter<FacetFilter>();

  emitFacetFilter(facetFilter: FacetFilter): void {
    this.filterFacets.emit(facetFilter);
  }
}
